import {ReactComponent as Text} from '../assets/icons/Text.svg'
import {ReactComponent as Camera} from '../assets/icons/Camera.svg'
import {ReactComponent as File} from '../assets/icons/File.svg'
import {ReactComponent as Arrow} from '../assets/icons/Arrow.svg'
import  {ReactComponent as Line} from '../assets/icons/Line.svg'
import {ReactComponent as Oval} from '../assets/icons/Oval.svg'
// import {ReactComponent as Puzzle} from '../assets/icons/Puzzle.svg'
import {ReactComponent as Redo} from '../assets/icons/Redo.svg'
import {ReactComponent as Undo} from '../assets/icons/Undo.svg'
import {ReactComponent as ZoomIn} from '../assets/icons/ZoomIn.svg'
import {ReactComponent as ZoomOut} from '../assets/icons/ZoomOut.svg'
import {ReactComponent as RedDotted} from '../assets/icons/redDotted.svg'
import {ReactComponent as RedSolid} from '../assets/icons/redSolid.svg'
import {ReactComponent as BlackDotted} from '../assets/icons/blackDotted.svg'
import {ReactComponent as RedWavy} from '../assets/icons/redWavy.svg'
import {ReactComponent as BlackSolid} from '../assets/icons/blackSolid.svg'
import {ReactComponent as AnnotationBox} from '../assets/icons/Annotation.svg'
import {ReactComponent as TextArea} from '../assets/icons/textArea.svg'
import {ReactComponent as ArrowLabel} from '../assets/icons/arrowText.svg'
import {ReactComponent as AddImage} from '../assets/icons/addimage.svg'
import {ReactComponent as Curve} from '../assets/icons/curve.svg'
import {ReactComponent as BlackDottedCurve} from '../assets/icons/blackDottedCurve.svg'
import {ReactComponent as RedDottedCurve} from '../assets/icons/redDottedCurve.svg'
import {ReactComponent as ShapesOption} from '../assets/icons/ShapesOption.svg'
import {ReactComponent as EllipseIcon} from '../assets/icons/ellipse.svg'
import {ReactComponent as SquareIcon} from '../assets/icons/square.svg'
import {ReactComponent as Group} from '../assets/icons/Group.svg'
import {ReactComponent as CropImage} from '../assets/icons/crop.svg'


import { wizardActionTypes as ActionTypes } from '../constants';
export const toolList = [
    {
        name: 'File',
        type: 'dropdown',
        icon: 'fas fa-retweet-alt',
        SVG: File,
        ActiveSVG: File,
        toolType:'plan',
        options: [
            // {name: "Plan", toolType: "plan", pageType: "newpage"},
            // {name: "Elevation Dimensions", toolType: "dimension", pageType: "newpage"},
            // {name: "Elevation Materials", toolType: "material", pageType: "newpage"},
            // {name: "Elevation Internals", toolType: "internal", pageType: "newpage"},
            // {name: "Appliances", toolType: "appliances", pageType: "newpage"},
            {name: "Electrical Services", toolType: "electricalservices", pageType: "newpage"},
            {name: "Plumbing Services", toolType: "plumbingservices", pageType: "newpage"},
            {name: "Civil work", toolType: "bespoke", pageType: "newpage", subMenu: [
                {name: "Civil Work - New", toolType: "civil_work", pageType: "newpage", showTag: true },
                {name: "Civil Floor Marble Laying", toolType: "civil_floor_marble_laying", pageType: "newpage", showTag: true},
                {name: "Civil Floor Tile Laying", toolType: "civil_floor_tile_laying", pageType: "newpage", showTag: true},
                {name: "Civil Wall Tile Laying", toolType: "civil_wall_tile_laying", pageType: "newpage", showTag: true},
            ]},
            {name: "Demolition", toolType: "demolition", pageType: "newpage", subMenu: [
                {name: "Demolition Service - Room", toolType: "demolition_room", pageType: "newpage", showTag: true},
            ]},
            {name: "False Ceiling", toolType: "falseCeiling", pageType: "newpage", subMenu: [
                {name: "False Ceiling - Overview", toolType: "custom_falseceiling_overview", pageType: "newpage", showTag: true},
                {name: "False Ceiling - Plan", toolType: "custom_falseceiling_plan", pageType: "newpage", showTag: true},
                {name: "False Ceiling - Section", toolType: "custom_falseceiling_section", pageType: "newpage", showTag: true},
                {name: "False Ceiling - Lighting & Electrical SOW", toolType: "custom_falseceiling_electrical_sow", pageType: "newpage", showTag: true},
                {name: "False Ceiling - Light Layout", toolType: "custom_falseceiling_light_layout", pageType: "newpage", showTag: true},
                {name: "False Ceiling - Looping Layout", toolType: "custom_falseceiling_looping_layout", pageType: "newpage", showTag: true},
                {name: "False Ceiling - SOW", toolType: "custom_scope_of_work_table", pageType: "newpage", showTag: true},
            ]},
            {name: "Shower Cubicles", toolType: "showercubicles", pageType: "newpage"},
            {name: "Countertop material & Services", toolType: "countertopmaterial&services", pageType: "newpage"},
            {name: "Drapes & Upholstery", toolType: "drapes&upholstery", pageType: "newpage"},
            {name: "Renovation", toolType: "renovation", pageType: "newpage"},
            {name: "Service", toolType: "bespoke", pageType: "newpage", subMenu: [
                {name: "Painting Service", toolType: "paintingservice", pageType: "newpage"},
                {name: "Wallpaper Service", toolType: "wallpaperservice", pageType: "newpage"},
                {name: "Flooring Service", toolType: "flooringservice", pageType: "newpage"},
                {name: "Lighting Service", toolType: "lightingservice", pageType: "newpage"},
            ]},
            {name: "Loose Furnitures", toolType: "loosefurnitures", pageType: "newpage"},
            {name: "Wall Electrical", toolType: "wall_electrical", pageType: "newpage", showTag: true},
            {name: "Lighting", toolType: "cabinet_light", pageType: "newpage", showTag: true},
            {name: "Wooden Flooring", toolType: "wooden_flooring", pageType: "newpage", showTag: true},
            {name: "Wall Painting", toolType: "wall_decor_new", pageType: "newpage", showTag: true},
            {name: "Countertop - SOW", toolType: "counter_top_material_sow", pageType: "newpage", showTag: true},
            {name: "Curtains", toolType: "curtains", pageType: "newpage", subMenu: [
                {name: "Curtains", toolType: "curtains", pageType: "newpage", showTag: true},
                {name: "Curtain Decor Mart", toolType: "curtains_decor", pageType: "newpage", showTag: true},
                {name: "Curtains The Yellow Dwelling", toolType: "curtains_yellow", pageType: "newpage", showTag: true},
                {name: "Curtains Aumbre Story", toolType: "curtains_aumbre", pageType: "newpage", showTag: true},
            ]},
            {name: "RFQ", toolType: "rfq", pageType: "newpage", showTag: true},
            // {name: "Custom", toolType: "custom", pageType: "newpage"}
        ]
    },
    // {
    //     name: 'Shapes',
    //     type: 'dropdown',
    //     icon: 'fas fa-retweet-alt',
    //     SVG: ShapesOption,
    //     ActiveSVG: ShapesOption,
    //     options:[
    //         {name:'Ellipse',toolType:ActionTypes.ELLIPSE},
    //         {name:'Rectangle',toolType:ActionTypes.RECTANGLE},
    //         {name:'Rectangle (dotted)',toolType:ActionTypes.DOTTED_RECTANGLE},
    //         {name:'White Box',toolType:ActionTypes.FILLED_RECTANGLE},
    //      ],
    //      toolType: ActionTypes.ELLIPSE
    // },
    {
        name: 'TextBox',
        type: 'dropdown',
        icon: 'fas fa-retweet-alt',
        SVG: Text,
        ActiveSVG: Text,
        toolType: ActionTypes.TEXT_BOX,
        options: [
            {name:'Plain Text',toolType: ActionTypes.TEXT_BOX, SVG: TextArea},
            {name:'Text Box',toolType: ActionTypes.TEXT_BOX_BORDER, SVG: AnnotationBox},
            {name:'Arrow Label',toolType: ActionTypes.ANNOTATION,SVG: ArrowLabel},
        ]

    },
    {
        name: 'Shapes',
        type: 'dropdown',
        icon: 'fas fa-retweet-alt',
        SVG: Arrow,
        ActiveSVG: Arrow,
        toolType:  ActionTypes.ARROW,
        options:[
            {name: 'Arrow',type: 'icon',SVG: Arrow,ActiveSVG: Arrow,toolType: ActionTypes.ARROW},
            {name:'Black Dotted',toolType:ActionTypes.DOTTED_LINE,color:'black',SVG:BlackDotted},
            {name:'Black Solid',toolType:ActionTypes.LINE,color:'black',SVG:BlackSolid},
            {name:'Red Dotted',toolType:ActionTypes.DOTTED_LINE,color:'red',SVG:RedDotted},
            {name:'Red Solid',toolType:ActionTypes.LINE,color:'red',SVG:RedSolid},
            {name:'Red Wave',toolType:ActionTypes.DOTTED_LINE,color:'red',SVG:RedWavy},
            {name:'Black Curve',toolType:ActionTypes.CURVE,color:'black',SVG:Curve},
            {name:'Black Curve(Dot)',toolType:ActionTypes.DOTTED_CURVE,color:'black',SVG:BlackDottedCurve},
            {name:'Red Curve(Dot)',toolType:ActionTypes.DOTTED_CURVE,color:'red',SVG:RedDottedCurve},
            {name:'Ellipse',toolType:ActionTypes.ELLIPSE,SVG:EllipseIcon},
            {name:'Rectangle',toolType:ActionTypes.RECTANGLE,SVG:SquareIcon},
            {name:'Rectangle (dotted)',toolType:ActionTypes.DOTTED_RECTANGLE,SVG: Group},
            {name:'White Box',toolType:ActionTypes.FILLED_RECTANGLE,SVG:SquareIcon},
            {name:'Crop Image',toolType:ActionTypes.CROP_IMAGE,SVG:CropImage},
        ]
    },
    //  {
    //     name: 'Ellipse',
    //     type: 'dropdown',
    //     icon: 'fas fa-retweet-alt',
    //     SVG: Oval,
    //     ActiveSVG: Oval,
    //      options:[
    //         {name:'Ellipse',toolType:ActionTypes.ELLIPSE},
    //         {name:'Rectangle',toolType:ActionTypes.RECTANGLE},
    //         {name:'Rectangle (dotted)',toolType:ActionTypes.DOTTED_RECTANGLE},
    //         {name:'White Box',toolType:ActionTypes.FILLED_RECTANGLE},
    //      ],
    //      toolType: ActionTypes.ELLIPSE
    // },
    {
        name: 'AddImage',
        type: 'dropdown',
        icon: 'fas fa-retweet-alt',
        SVG: AddImage,
        ActiveSVG: AddImage,
        options:[
            {name:'From Local',toolType:ActionTypes.LOCAL_IMAGE},
            {name:'From SC-Gallery',toolType:ActionTypes.SPACECRAFT_IMAGE},
        ],
        toolType: ActionTypes.IMAGEDROPDOWN

    },
    {
        name: 'Measurement',
        type: 'icon',
        icon: 'fas fa-retweet-alt',
        SVG: Camera,
        ActiveSVG: Camera,
        toolType: ActionTypes.MEASUREMENT
    },
    
    // {
    //      name: 'AddImage',
    //      type: 'icon',
    //      icon: 'fas fa-retweet-alt',
    //      SVG: AddImage,
    //      ActiveSVG: AddImage,
    //      toolType: ActionTypes.ADD_IMAGE
    // },
    //}
    // {
    //     name: 'Undo',
    //     type: 'icon',
    //     icon: 'fas fa-retweet-alt',
    //     SVG: Undo,
    //     ActiveSVG: Undo,
    //     toolType:''
    // },

    // {
    //     name: 'Redo',
    //     type: 'icon',
    //     icon: 'fas fa-retweet-alt',
    //     SVG: Redo,
    //     ActiveSVG: Redo,
    //     toolType:''
    // },
    // {
    //     name: 'ZoomIn',
    //     type: 'icon',
    //     icon: 'fas fa-retweet-alt',
    //     SVG: ZoomIn,
    //     ActiveSVG: ZoomIn,
    //     toolType: ActionTypes.ZOOM_IN
    // },
    // {
    //     name: 'ZoomOut',
    //     type: 'icon',
    //     icon: 'fas fa-retweet-alt',
    //     SVG: ZoomOut,
    //     ActiveSVG: ZoomOut,
    //     toolType: ActionTypes.ZOOM_OUT
    // },
    // {
    //     name: 'RoomParts',
    //     type: 'icon',
    //     icon: 'fas fa-retweet-alt',
    //     SVG: Puzzle,
    //     ActiveSVG: Puzzle,
    //     toolType: ActionTypes.IMAGE
    // },

]
export const undoRedoList = [
    {
        name: 'Undo',
        type: 'icon',
        icon: 'fas fa-retweet-alt',
        SVG: Undo,
        ActiveSVG: Undo,
        toolType: ActionTypes.UNDO
    },
    {
        name: 'Redo',
        type: 'icon',
        icon: 'fas fa-retweet-alt',
        SVG: Redo,
        ActiveSVG: Redo,
        toolType: ActionTypes.REDO

    }
]
export const zoomIconList = [
    {
        name: 'ZoomIn',
        type: 'icon',
        icon: 'fas fa-retweet-alt',
        SVG: ZoomIn,
        ActiveSVG: ZoomIn,
        toolType: ActionTypes.ZOOM_IN
    },
    {
        name: 'ZoomOut',
        type: 'icon',
        icon: 'fas fa-retweet-alt',
        SVG: ZoomOut,
        ActiveSVG: ZoomOut,
        toolType: ActionTypes.ZOOM_OUT
    }
]
